import { locationIdFormat } from "@redotech/redo-model/ids";
import { WarehouseGridSchema } from "@redotech/redo-model/wms/schema/warehouse-grid";
import * as z from "zod/v4";

export const upsertWarehouseLayout = {
  name: "upsertWarehouseLayout" as const,
  input: z.object({
    layoutId: z.string().nullish(),
    crdbLocationId: locationIdFormat.schema.nullish(),
    warehouseGrid: WarehouseGridSchema,
    expectedUpdatedAt: z.date().nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    layoutId: z.string().nullish(),
    updatedAt: z.date().nullish(),
    versionConflict: z.boolean().optional(),
  }),
};
